import AuthClient from './AuthClient'

// Primitives d'authentification « légères », extraites de withAuthent.tsx.
// withAuthent.tsx tire useEntity + CONSTANT_ROUTES (tout le shell), donc
// importer getSession depuis withAuthent traînait tout ce graphe dans chaque module
// l'utilisant (dont tanstackQuery → toutes les pages, y compris /patient).
// Ce module n'a qu'AuthClient comme dépendance, il reste donc minimal.

export const NAME_TOKEN_HREF_SWITH_USER = 'switchHref'
export const NAME_TOKEN_ENTITY_SWITH_USER = 'switchEntity'

export const authClient = new AuthClient()

// Bind methods to preserve `this` context when exported
export const signIn = authClient.signIn.bind(authClient)
export const signOut = authClient.signOut.bind(authClient)
export const getSession = authClient.getSession.bind(authClient)
export const overrideRolesSession = authClient.overrideRolesSession.bind(authClient)
export const switchAccount = authClient.switchAccount.bind(authClient)

// Rôles effectifs de la session : en mode switch-user, ce sont les rôles de
// l'utilisateur impersonné (switchUserRoles), sinon ceux de l'utilisateur connecté.
export const getSessionRoles = (): string[] => {
  const session = getSession()
  return session?.switchUserRoles?.length ? session.switchUserRoles : session?.user?.roles ?? []
}

// Déconnexion de l'app mobile (WebView React Native) : on prévient le conteneur
// natif et on purge les tokens du localStorage. Vit ici (module léger) pour être
// appelable depuis la couche réseau sans réintroduire le cycle vers withAuthent.
export const logoutMobile = async () => {
  if (typeof window !== 'undefined' && (window as any).ReactNativeWebView) {
    ;(window as any).ReactNativeWebView.postMessage(JSON.stringify({ type: 'logoutAppMobile' }))
    localStorage.removeItem('token')
    localStorage.removeItem('refreshToken')
  }
}

export const logout = async () => {
  await logoutMobile()
  // Verrou coffre TOTP : on oblige un nouveau déverrouillage après chaque logout.
  // Clé dupliquée volontairement (cf. TOTP_UNLOCK_KEY) pour garder ce module sans dépendance UI.
  if (typeof window !== 'undefined') sessionStorage.removeItem('pharmedigroup-totp-unlocked')
  await authClient.signOut({ redirect: true, callbackUrl: '/login' })
}
